// Range indicator component for displaying movement distance

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Range indicator component
 * Displays movement distance near the cursor during movement
 */
class RangeIndicator extends BaseComponent {
  static properties = {
    show: { type: Boolean },
    x: { type: Number },
    y: { type: Number },
    feetMoved: { type: Number, attribute: 'feet-moved' },
    maxFeet: { type: Number, attribute: 'max-feet' },
  };

  static styles = css`
    :host {
      display: block;
    }

    .range-indicator {
      position: fixed;
      pointer-events: none;
      z-index: 10000;
      transform: translate(-50%, -100%);
      display: flex;
      align-items: center;
      gap: 6px;
      background: rgba(0, 0, 0, 0.85);
      border: 1px solid rgba(255, 255, 255, 0.3);
      padding: 6px 10px;
      border-radius: 4px;
      color: white;
      font-size: 14px;
      font-weight: bold;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4));
      margin-top: -8px;
    }

    .range-text {
      white-space: nowrap;
    }
  `;

  constructor() {
    super();
    this.show = false;
    this.x = 0;
    this.y = 0;
    this.feetMoved = 0;
    this.maxFeet = 0;
  }

  _renderFootprintsIcon() {
    return html`
      <svg
        width="16"
        height="16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"
        />
        <path
          d="M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"
        />
        <path d="M16 17h4" />
        <path d="M4 13h4" />
      </svg>
    `;
  }

  render() {
    if (!this.show) {
      return html``;
    }

    return html`
      <div class="range-indicator" style="left: ${this.x}px; top: ${this.y}px;">
        ${this._renderFootprintsIcon()}
        <span class="range-text">${this.feetMoved} of ${this.maxFeet}</span>
      </div>
    `;
  }
}

customElements.define('range-indicator', RangeIndicator);
